import { Button } from "@mui/material";
import { NewAnalysisIcon } from "Components/_Shared/Icons/Icons";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

export const NewAnalysisButton = () => {
  const { t } = useResource();
  return (
    <UnstyledLink to={AppRouting.NewAnalysis.path()}>
      <Button variant="contained" startIcon={<NewAnalysisIcon />}>
        {t(Resources.Common.NewAnalysis)}
      </Button>
    </UnstyledLink>
  );
};
